import { PROGRESSION_PARENT_MODEL, PROGRESSION_TABLE_MODEL } from '../model';
import { useMemo } from 'react';
import { StyledCell } from '../../../../../../ResourceAllocationOverview/JiraStats/useTableRows/Row.style';
import AssigneesCell from '../../../../../../ResourceAllocationOverview/JiraStats/useTableRows/cell-components/AssigneesCell';
import { PROGRESSION_CELLS, mapRowToProviderCommonCells } from '../common.rows';
import _ from 'lodash';

const useParentOneRows = ({ data, pmProvider, isTreeHierarchyEnabled }) => {
  const items = data?.data || [];

  const rows = useMemo(() => {
    return _.map(items, row => {
      const commonCells = mapRowToProviderCommonCells(row)[pmProvider];
      const assignees = row?.[PROGRESSION_PARENT_MODEL.ASSIGNEES];
      const total =
        row?.[
          isTreeHierarchyEnabled
            ? PROGRESSION_PARENT_MODEL.CHILDREN
            : PROGRESSION_PARENT_MODEL.TOTAL
        ];

      return {
        ...row,
        ...commonCells,
        ...PROGRESSION_CELLS.PARENT(row),
        [PROGRESSION_TABLE_MODEL.ASSIGNEES_CELL]: (
          <AssigneesCell assignees={assignees} />
        ),
        ...PROGRESSION_CELLS.PROGRESS(row),
        [PROGRESSION_TABLE_MODEL.TOTAL_CELL]: <StyledCell>{total}</StyledCell>,
        ...PROGRESSION_CELLS.STATUS(row)
      };
    }).filter(Boolean);
  }, [data]);

  return rows;
};

export default useParentOneRows;
